import BalanceSheetAssetsModal from '../../pages/CompanyAdminPages/CompanyMap/components/BusinessStructure/components/BalanceSheetAssetsModal/BalanceSheetAssetsModal';
import CustomerModal from '../../pages/CompanyAdminPages/CompanyMap/components/BusinessStructure/components/CustomerModal/CustomerModal';
import ProductModal from '../../pages/CompanyAdminPages/CompanyMap/components/BusinessStructure/components/ProductModal/ProductModal';
import ProfitCentreModal from '../../pages/CompanyAdminPages/CompanyMap/components/BusinessStructure/components/ProfitCentreModal';
import SupplierModal from '../../pages/CompanyAdminPages/CompanyMap/components/BusinessStructure/components/SupplierModal/SupplierModal';

import type { ICompanyMapModals } from './interfaces/ICompanyMapModals';

function CompanyMapModals({
  valueChainMapId,
  currentTargetSwimlaneId,
  isProfitCentreModalOpen,
  closeProfitCenterModal,
  selectedProfitCennter,
  setSelectedProfitCenter,
  isCustomerModalOpen,
  setSelectedCustomer,
  selectedCustomer,
  isSupplierModalOpen,
  setSelectedSupplier,
  selectedSupplier,
  isInputProductModalOpen,
  setSelectedInputProduct,
  selectedInputProduct,
  isBalanceSheetAssetsModalOpen,
  setSelectedBalanceSheetAssets,
  selectedBalanceSheetAssets,
}: ICompanyMapModals) {
  return (
    <>
      {isProfitCentreModalOpen ? (
        <ProfitCentreModal
          valueChainMapId={valueChainMapId || ''}
          closeProfitCenterModal={closeProfitCenterModal}
          selectedProfitCennter={selectedProfitCennter}
          setSelectedProfitCenter={setSelectedProfitCenter}
          currentTargetSwimlaneId={currentTargetSwimlaneId}
          valueChainForm
        />
      ) : null}
      {isCustomerModalOpen ? (
        <CustomerModal
          closeProfitCenterModal={closeProfitCenterModal}
          valueChainMapId={valueChainMapId || ''}
          setSelectedCustomer={setSelectedCustomer}
          currentTargetSwimlaneId={currentTargetSwimlaneId}
          selectedCustomer={selectedCustomer}
          valueChainForm
        />
      ) : null}
      {isSupplierModalOpen ? (
        <SupplierModal
          closeProfitCenterModal={closeProfitCenterModal}
          valueChainMapId={valueChainMapId || ''}
          setSelectedSupplier={setSelectedSupplier}
          currentTargetSwimlaneId={currentTargetSwimlaneId}
          selectedSupplier={selectedSupplier}
          valueChainForm
        />
      ) : null}
      {isInputProductModalOpen ? (
        <ProductModal
          closeProfitCenterModal={closeProfitCenterModal}
          valueChainMapId={valueChainMapId || ''}
          setSelectedProduct={setSelectedInputProduct}
          currentTargetSwimlaneId={currentTargetSwimlaneId}
          selectedProduct={selectedInputProduct}
          valueChainForm
        />
      ) : null}
      {isBalanceSheetAssetsModalOpen ? (
        <BalanceSheetAssetsModal
          closeProfitCenterModal={closeProfitCenterModal}
          valueChainMapId={valueChainMapId || ''}
          setSelectedBalanceSheetAssets={setSelectedBalanceSheetAssets}
          currentTargetSwimlaneId={currentTargetSwimlaneId}
          selectedBalanceSheetAssets={selectedBalanceSheetAssets}
          valueChainForm
        />
      ) : null}
    </>
  );
}

export default CompanyMapModals;
